import { conjoin } from "@silo/utils";
import { cn } from "../../utils/class-names";
import {
  MarketCardCollateral,
  MarketCardDebt,
  MarketCardProtected,
} from "./market-card";
import { PositionCollateral } from "./position/position-collateral";
import { PositionDebt } from "./position/position-debt";
import { PositionProtected } from "./position/position-protected";
import { PositionReward } from "@silo/types";

export const AprDisplayV2 = {
  PositionCollateral,
  PositionProtected,
  PositionDebt,

  MarketCardCollateral,
  MarketCardProtected,
  MarketCardDebt,
};

interface ProtectedRewardsMessageProps {
  className?: string;
  protectedRewards: PositionReward[];
}

export function ProtectedRewardsMessage({
  className,
  protectedRewards,
}: ProtectedRewardsMessageProps): JSX.Element {
  return (
    <div
      className={cn(
        "p-2.5 rounded-lg bg-amber-300/10 text-amber-300",
        className
      )}
    >
      Depositors in this market earn rewards APR in{" "}
      {conjoin(protectedRewards.map((reward) => reward.rewardTokenSymbol))} on a
      non-borrowable (protected) deposit.
    </div>
  );
}

interface NetYieldMessageProps {
  className?: string;
}

export function NetYieldMessage({
  className,
}: NetYieldMessageProps): JSX.Element {
  return (
    <div
      className={cn(
        "rounded-lg bg-green-400/10 p-2.5 text-green-400 font-medium",
        className
      )}
    >
      You make a positive yield on borrowing
    </div>
  );
}
